/**
 * Finds an attribute in the given array by its key.
 *
 * @param {Array} attributes - The array of attributes to search in.
 * @param {string} key - The key of the attribute to find.
 * @returns {Object|undefined} - The found attribute object, or undefined if not found.
 */
export function findAttributeByKey(attributes, key) {
  return attributes?.find((attribute) => attribute?.attribute?.key === key)
}

/**
 * Adds the color attribute to the article object.
 *
 * @param {Object} article - The article object to add the color attribute to.
 * @returns {Object} - The modified article object.
 */
export function addColorAttribute(article) {
  const colorAttribute = findAttributeByKey(article.attributes, "Farbe")

  if (colorAttribute) {
    article.color = colorAttribute?.value
  }

  return article
}
